import React, {useState} from 'react';
 
import { Form, Button, Row, Col, ListGroup, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft,faXmark, faFileExce } from "@fortawesome/free-solid-svg-icons"; 
import { Link} from "react-router-dom";
 
 
 
import Rightbar from './Rightbar';
  
export default function ExhibitorPortalhome(){ 
    const [date, setDate] = useState(new Date());
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
    setsidebar(!sidebar);
    setmainbar(!mainbar);
}
return(
  <>
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
            <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
                  <h1>OFFICIAL CATALOGUE LISTING</h1>
                            <p>
                            Please list below exactly how you would like your gallery to be presented in the online
catalogue, as well as in all printed materials, including badges, invitations, signage, etc.
Please pay special attention to case settings such as CAPS, as what is typed here is exactly
how you will be listed    </p>
                            
                            <Form>
                                
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Gallery Name<span class="star">*</span>
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Address<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}  controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Address 2
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}  controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        City<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        State
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Select aria-label="Default select example">
                                            <option>Select a state...</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Zip / Postal Code
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Country<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Select aria-label="Default select example">
                                            <option>Select a country...</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        City #2
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Country #2
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Select aria-label="Default select example">
                                            <option>Select a country...</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Telephone<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Mobile
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Email<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="email" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Website<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                
                                <hr/>

                                <Form.Group as={Row}  controlId="formHorizontalEmail">
                                    <Form.Label column sm={3} >
                                        Artist<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={9}>
                                        <p>- Please list the artists that your gallery represents <br />
                                            (separate each name by a comma or enter onto a new line)
                                        </p>
                                    </Col>
                                </Form.Group>
                                
                                <Form.Control  as="textarea" rows={3}/>
<div className='text-center'>
                                <Button className='common-btn'>Edit</Button>
                                </div>
                            </Form>
                            
                  </div>
            </div>
         </div>
      </div>
   </div>
</section>  

 
</>
)
}
